module.exports = __webpack_public_path__ + "static/plain-regular-fd605168c26bf8c1097174966351980b.otf";